import {HttpClient} from '@angular/common/http';
import {HttpUtils} from '../shared/http.utils';
import {Injectable} from '@angular/core';
import {SubscriptionFilters} from "../model/filters/subscription-filters";
import {FiltersUtils} from "../shared/filters.utils";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SubscriptionsService {

  private readonly subscriptionsURL: string;


  constructor(private http: HttpClient) {
    this.subscriptionsURL = '/api/subscriptions';
  }

  public getSubscriptions(filters?: SubscriptionFilters): Observable<any> {
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams(null, null));
    if (filters != null) {
      options = SubscriptionsService.setSubscriptionParameters(options, filters);
    }
    return this.http.get<any>(this.subscriptionsURL, options);
  }

  private static setSubscriptionParameters(options: any, filters: SubscriptionFilters) {
    options.params["username"] = FiltersUtils.getFilterTrim(filters.username);
    options.params["startDate"] = FiltersUtils.getFilter(filters.startDate);
    options.params["endDate"] = FiltersUtils.getFilter(filters.endDate);
    options.params["serialNumber"] = FiltersUtils.getFilterTrim(filters.serialNumber);
    options.params["active"] = FiltersUtils.getFilterBoolean(filters.active);
    options.params["organizationUuids"] = FiltersUtils.getFilter(filters.organizationUuids);
    options.params["sortField"] = FiltersUtils.getFilter(filters.sortField);
    options.params["sortOrder"] = FiltersUtils.getFilter(filters.sortOrder);
    return options;
  }

}
